import NetworkDetectorComponent from './hoc/NetworkDetectorComponent';
import AppRoutes from './routes';
import './App.scss';

const App = () => {
  return <AppRoutes />;
};

export default NetworkDetectorComponent(App);
